import { DishModel } from '../pages/pub-menu/create/builder/models'

export const getDishBlockPricingValue = (
  dish: DishModel,
  currencySymbol: string
): string => {
  if (dish.price === '' || dish.price === null || dish.price === undefined) {
    return ''
  }

  const fractionDigits: number = currencySymbol === 'Ft' ? 0 : 2

  return `${parseFloat(dish.price as string).toFixed(
    fractionDigits
  )} ${currencySymbol}`
}
